import { loadManifest } from '@angular-architects/module-federation';
import { environment } from './environments/environment';

loadManifest(`/assets/${environment.manifestFile}`, true)
  .catch((error) => console.error(error))
  .then((_) => import('./bootstrap'))
  .catch((err) => console.error(err));
